/** The move-vs-duplicate decision. Two callers: dropping a work code onto a
 *  level that already carries it, and dropping a BULK-dragged selection
 *  (count set — the title reads by count instead of code). Semantics live in
 *  the host, not here. */
import React from "react";
import "./DropConflictModal.css";

interface Props {
  code?: string;
  color?: string;
  codeName?: string;
  leafLabel?: string;
  /** Bulk variant: how many activities the drop carries. */
  count?: number;
  onMove: () => void;
  onDuplicate: () => void;
  onClose: () => void;
}

const DropConflictModal: React.FC<Props> = ({
  code,
  color,
  codeName,
  leafLabel,
  count,
  onMove,
  onDuplicate,
  onClose,
}) => (
  <div className="drop-conflict-overlay" onMouseDown={onClose}>
    <div className="drop-conflict" onMouseDown={(e) => e.stopPropagation()}>
      <button type="button" className="drop-conflict-x" aria-label="Close" onClick={onClose}>
        ✕
      </button>
      <div className="drop-conflict-title">
        {count != null ? (
          <>Move or duplicate the {count} selected activit{count === 1 ? "y" : "ies"}?</>
        ) : (
          <>
            <span className="drop-conflict-pill" style={{ background: color }}>
              {code}
            </span>
            {codeName} already exists on {leafLabel}
          </>
        )}
      </div>
      <div className="drop-conflict-actions">
        <button type="button" className="drop-conflict-btn drop-conflict-btn--move" onClick={onMove}>
          {count != null ? "Move them here" : "Move it here"}
        </button>
        <button type="button" className="drop-conflict-btn" onClick={onDuplicate}>
          Duplicate
        </button>
      </div>
    </div>
  </div>
);

export default DropConflictModal;
